export enum SOCIAL_TEST_IDS {
  VIEW_USER_PROFILE = "id_view_user_profile",
  SEARCH_BAR = "id_search_bar",
  FEED_SECTION = "id_feed_section",
  POST = "id_post",
  LIKE = "id_like",
  LIKE_NUMBER = "id_like_number",
  SHARE_ICON = "id_share_icon",
  REPORT_ICON = "id_report_icon",
  POST_HAMBURGER = "id_post_hamburger",
  COMMENT_BOX = "id_comment_box",
  COMMENT_NUMBER = "id_comment_number",
  COMMENT_INPUT_BOX = "id_comment_input_box",
  COMMENT_SEND_BUTTON_DISABLED = "id_comment_send_button_disabled",
  COMMENT_SEND_BUTTON = "id_comment_send_button",
  COMMENT_LIKE = "id_comment_like",
  COMMENT_LIKE_COUNT = "id_comment_like_count",
  COMMENT_DISLIKE = "id_comment_dislike",
  COMMENT_DISLIKE_COUNT = "id_comment_dislike_count",

  COMMENT_HAMBURGER = "id_comment_hamburger",
  NESTED_COMMENT_BUTTON = "id_nested_comment_button",
  NESTED_COMMENT_COUNT = "id_nested_comment_count",
  NESTED_COMMENT_INPUT_BOX = "id_nested_comment_input_box",
  NESTED_COMMENT_LIKE = "id_nested_comment_like",
  NESTED_COMMENT_DISLIKE = "id_nested_comment_dislike",
  NESTED_COMMENT_LIKE_COUNT = "id_nested_comment_like_count",
  NESTED_COMMENT_DISLIKE_COUNT = "id_nested_comment_dislike_count",

  NESTED_COMMENT_HAMBURGER = "id_nested_comment_hamburger",
  SEARCHED_USER = "id_searched_user",
  USER_PROFILE = "id_user_profile",
  CTA = "id_cta",
  FOLLOWER_TAB = "id_follower_tab",
  FOLLOWING_TAB = "id_following_tab",
  FOLLOW_BUTTON = "id_follow_button",
  VIEW_ALL_CERTIFICATES = "id_view_all_certificates",
  UNFOLLOW_BUTTON = "id_unfollow_button",
  HAMBURGER_UNFOLLOW_ICON = "id_hamburger_unfollow",
  FOLLOWERS_LIST = "id_followers_list",
  FOLLOWING_LIST = "id_following_list",
  MUTUAL_LIST = "id_mutual_list",
  NEW_POST = "new_post",
  PROFILE_WORK_EXPERIENCE = "profile_work_experience",
  PROFILE_WORK_EXPERIENCE_ROLE = "profile_work_experience_role",
  PROFILE_WORK_EXPERIENCE_TIME = "profile_work_experience_time",
  PROFILE_CERTIFICATES_MEDALS = "profile_certificates_medals",
  PROFILE_CERTIFICATE_TITLE = "profile_certificate_title",
  PROFILE_SUGGESTIONS_TITLE = "profile_suggestions_title",
  PROFILE_SUGGESTIONS_VIEW_ALL = "profile_suggestions_view_all",
  CONTACT_SYNC_CONNECT_BUTTON = "contact_sync_connect_button",
  CONTACT_SUGGESTION_CARD = "contact_suggestion_card",
  ADD_CONTACT_BANNER = "add_contact_banner",
  HELLO_TAB_ICON = "hello_tab_icon",
  SOCIAL_NOTIFICATION_ICON = "social_notification_icon"
}

export enum SOCIAL_ACCESSIBILITY_LABEL {
  VIEW_USER_PROFILE = "View User Profile",
  SEARCH_BAR = "Search Bar",
  FEED_SECTION = "Feed List",
  POST = "Post",
  LIKE = "Like",
  LIKE_NUMBER = "Like Count",
  SHARE_ICON = "Share Icon",
  REPORT_ICON = "Report Icon",
  POST_HAMBURGER = "Post Hamburger",
  COMMENT_BOX = "Comment Box",
  COMMENT_NUMBER = "Comment Number",
  COMMENT_INPUT_BOX = "Comment Input Box",
  COMMENT_SEND_BUTTON_DISABLED = "Comment Send Button Disabled",
  COMMENT_SEND_BUTTON = "Comment Send Button",
  COMMENT_LIKE = "Comment Like",
  COMMENT_LIKE_COUNT = "Comment Like Count",
  COMMENT_DISLIKE = "Comment Dislike",
  COMMENT_DISLIKE_COUNT = "Comment Dislike Count",

  COMMENT_HAMBURGER = "Comment Hamburger",
  NESTED_COMMENT_BUTTON = "Nested Comment Button",
  NESTED_COMMENT_COUNT = "Nested Comment Count",
  NESTED_COMMENT_INPUT_BOX = "Nested Comment Input Box",
  NESTED_COMMENT_LIKE = "Nested Comment Like",
  NESTED_COMMENT_DISLIKE = "Nested Comment Dislike",
  NESTED_COMMENT_LIKE_COUNT = "Nested Comment Like Count",
  NESTED_COMMENT_DISLIKE_COUNT = "Nested Comment Dislike Count",

  NESTED_COMMENT_HAMBURGER = "Nested Comment Hamburger",
  SEARCHED_USER = "Searched User",
  USER_PROFILE = "User Profile",
  CTA = "CTA",
  FOLLOWER_TAB = "Follower Tab",
  FOLLOWING_TAB = "Following Tab",
  FOLLOW_BUTTON = "Follow Button",
  VIEW_ALL_CERTIFICATES = "View All Certificates",
  UNFOLLOW_BUTTON = "Unfollow Button",
  HAMBURGER_UNFOLLOW_ICON = "Hamburger Icon For Unfollow",
  FOLLOWERS_LIST = "Followers List",
  FOLLOWING_LIST = "Following List",
  MUTUAL_LIST = "Mutual List"
}
